function calculatePrice(type, width, height) {
  const table = {
    450: { 900: 69, 1050: 71, 1200: 73 },
    600: { 900: 73, 1050: 75, 1200: 79 },
    750: { 900: 78, 1050: 82, 1200: 85 }
  };

  const widths = Object.keys(table).map(Number);
  const matchedWidth = widths.find(w => width <= w);

  if (!matchedWidth) return 0;

  const heights = table[matchedWidth];
  const heightKeys = Object.keys(heights).map(Number);
  const matchedHeight = heightKeys.find(h => height <= h);

  if (!matchedHeight) return 0;

  return heights[matchedHeight];
}